var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObrsvaz({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H2.5C1.125 0 0.0125 1.125 0.0125 2.5L0 25L5 20H22.5C23.875 20 25 18.875 25 17.5V2.5C25 1.125 23.875 0 22.5 0ZM22.5 17.5H3.9625L3.225 18.2375L2.5 18.9625V2.5H22.5V17.5ZM11.25 12.5H13.75V15H11.25V12.5ZM11.25 5H13.75V10H11.25V5Z",
    fill: "#4B2D10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObrsvaz);
export default __webpack_public_path__ + "static/media/obrsvaz.696a449ca486487751dc518153dbaec8.svg";
export { ForwardRef as ReactComponent };